import { render, staticRenderFns } from "./ReviewIconStar.vue?vue&type=template&id=40408320&scoped=true&"
import script from "./ReviewIconStar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewIconStar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewIconStar.vue?vue&type=style&index=0&id=40408320&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40408320",
  null
  
)

export default component.exports